arsluna.ecommerce.productDetail = (function (arsluna, $) {
    "use strict";

    var self = {},
        productId,
        productUid,
        form;

    function init() {
        onReady();
        bindEvents();
    }

    function onReady() {
        var $product = $('.product-detail');
        if (!$product.length) return;

        productId = $product.data('product_id');
        productUid = $product.data('product_uid');
        form = $('#purchase-' + productUid);

        $('#product-detail-tabs-' + productId)
            .tabs("option", "active", 1);

        initSpinner();
    }
    function bindEvents() {
        $(document).on("click", ".button-add-to-cart-big", function (event) {
            event.preventDefault();
            if (form.find('[name="purchase_type"]').val() === "product_options_multiple") {
                classEcommerceJS.addProductsToCart(form);
            } else {
                classEcommerceJS.pFormAddToCart(form);
            }
            return false;
        });
        $(document).on("click", "a.product-option", function (event) {
            event.preventDefault();
            classEcommerceJS.setProduct($(this), 'detail', 'big');
            return false;
        });
        $("#celoten-opis-link").on('click', function (event) {
            var $target = $(this.hash);
            // Make sure this.hash has a value before overriding default behavior
            if ($target.length) {
                // Prevent default anchor click behavior
                event.preventDefault();

                // Using jQuery's animate() method to add smooth page scroll
                // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                $('html, body').animate({
                    scrollTop: $target.offset().top
                }, 800, function () {

                    // Add hash (#) to URL when done scrolling (default click behavior)
                    window.location.hash = hash;
                });
            } // End if
        });
        $("#product-detail-options-button-show").on('click', function (event) {
            var $target = $(this.hash);
            // Make sure this.hash has a value before overriding default behavior
            if ($target.length) {
                // Prevent default anchor click behavior
                event.preventDefault();

                // Using jQuery's animate() method to add smooth page scroll
                // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                $('#product-detail-tabs-' + productId).tabs("option", "active", 1);
                $('html, body').animate({
                    scrollTop: $target.offset().top
                }, 800, function () {
                    // Add hash (#) to URL when done scrolling (default click behavior)
                    window.location.hash = hash;

                });
            } // End if
        });
    }
    function initSpinner() {
        $("#numProductsPurchase").spinner({
            culture: "sl",
            min: parseFloat(form.find('[name="min_quantity"]').val()) || 0,
            max: parseFloat(form.find('[name="max_quantity"]').val()) || 9999,
            step: parseFloat(form.find('[name="step"]').val()) || 1,
            numberFormat: "n"
        });
    }

    self.init = init;
    return self;

})(window.arsluna, jQuery);

arsluna.ecommerce.productDetail.init();